import React, { createContext, useState, useCallback } from 'react';
import httpHandler from '../helpers/httpHandler';
import { notification } from 'antd';
import { useStore } from '../store/useStore';
import { postRequest } from '../helpers/httpHandler2';
import { CheckCircleOutlined } from '@ant-design/icons';
import {
  setCrossDomainMemberFlag,
  clearCrossDomainMemberFlag
} from '../helpers/crossDomainAccess';

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user_bundle, setUserBundle] = useState(null);

  const requestUserBundleUpdate = useCallback(async () => {
    let data;
    try {
      data = await httpHandler.get('/api/users/');
    } catch (error) {
      window.localStorage.removeItem('CWAuthToken');
      clearCrossDomainMemberFlag();
      window.location.href = '/login';
      return;
    }
    const user_bundle = JSON.parse(data.user_bundle);
    setUserBundle(user_bundle);

    const currentUrl = new URL(window.location.href);
    const joinTeamCode =
      currentUrl.searchParams.get('joinTeamCode') ||
      window.localStorage.getItem('joinTeamCode');
    if (joinTeamCode) {
      try {
        const team = await postRequest('/api/teams/invite/accept', {
          joinTeamSecretCode: joinTeamCode
        });
        notification.open({
          message: 'Joined Team',
          description: `Succesfully joined ${team.teamName}!`,
          icon: <CheckCircleOutlined style={{ color: '#48a1ff' }} />,
          duration: 0
        });
        window.localStorage.removeItem('joinTeamCode');
      } catch (error) {
        notification.open({
          message: 'Error Joining Team',
          description: 'Unable to Join team.'
        });
        window.localStorage.removeItem('joinTeamCode');
      }
    }

    const teamStaticCode =
      currentUrl.searchParams.get('tsc') || window.localStorage.getItem('tsc');
    if (teamStaticCode) {
      try {
        await postRequest(`/api/teams/requests`, {
          staticCode: teamStaticCode
        });
        notification.open({
          message: 'Sent join team request to the team leader'
        });
      } catch (error) {
        notification.open({ message: error.message });
        console.error('error making request', error);
      }
      window.localStorage.removeItem('tsc');
      currentUrl.searchParams.delete('tsc');
      window.history.pushState({}, document.title, window.location.pathname);
    }

    window.localStorage.setItem('CWAuthToken', data.token);
    // Lets gated pages on clubwealth.com recognise a signed-in member.
    setCrossDomainMemberFlag();
    await useStore.getState().teamsApi.fetchUserTeams();
    const currentTeam = window.localStorage.getItem('currentTeam');
    const userTeams = await useStore.getState().userTeams;

    if (!currentTeam && userTeams.length) {
      window.localStorage.setItem('currentTeam', JSON.stringify(userTeams[0]));
    }
  }, []);

  // If you want to expose updateUserBundleDirectly:
  const updateUserBundleDirectly = (user_bundle) => {
    setUserBundle(user_bundle);
  };

  return (
    <UserContext.Provider
      value={{
        user_bundle,
        requestUserBundleUpdate,
        updateUserBundleDirectly
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export default UserContext;
